module.exports = __webpack_public_path__ + "img/d-dutos-off.a71fd8a8.png";